import { GlobalStyles } from "@mui/material";

// App-wide scrollbar: thin, light grey on a transparent track, a little darker on hover.
// Always present (so long tables still show there is more to scroll) but barely noticeable.
// Firefox uses scrollbar-width/color; Chrome, Edge and Safari use the ::-webkit-scrollbar rules.
export const AppScrollbarStyles = () => (
  <GlobalStyles
    styles={{
      "*": {
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(15, 23, 42, 0.18) transparent",
      },
      "*::-webkit-scrollbar": {
        width: 8,
        height: 8,
      },
      "*::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(15, 23, 42, 0.18)",
        borderRadius: 8,
        // transparent border + padding-box keeps the visible thumb slimmer than its 8px hit area
        border: "2px solid transparent",
        backgroundClip: "padding-box",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "rgba(15, 23, 42, 0.32)",
      },
      "*::-webkit-scrollbar-corner": {
        background: "transparent",
      },
    }}
  />
);
